<script setup>
import { defineProps, toRefs, defineEmits } from 'vue';
import MButton from 'src/components/MButton/index.vue';
import { useIns } from 'src/utils/v2_helper/common';

const app = useIns();

const emit = defineEmits(['onSubmit']);
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: null,
  },
});
const { disabled, data } = toRefs(props);

const onSubmit = () => emit('onSubmit');
</script>
<template>
  <section class="footer">
    <slot />
    <MButton
      class="footer-btn"
      primary
      bold
      v-bind="$attrs"
      :disabled="disabled"
      @click="onSubmit"
    >{{ data.text }} · {{ $n(data.price, 'currency', 'id-ID') }}</MButton>
  </section>
</template>

<style lang="scss" socped>
*[bold],
.bold {
  font-weight: bold;
}
*[text-c],
.text-c {
  text-align: center;
}
.footer {
  padding: 4px 16px 8px;
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: solid 1px $border;
  background: #fff;
  &-btn {
    width: 100%;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: $primary;
    border-radius: 8px;
    margin-top: 4px;
    @extend .text-c;
    @extend .bold;
  }
}
</style>
